// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pic{
  display: flex;
width: 80%;
margin-left: 10%;
margin-right: 10%;

}

.pic.home {
width: 100% !important;
margin-left: 10%;
margin-right: 10%;
width: 80%;
display: flex;
margin-left: 0% !important;
margin-right: 0% !important;
margin-bottom: 0px;
margin-top: -50px;
}

.image4{
width: 600px;
height: 400px;
margin-top: 3rem;
display: block;
margin-left: auto;
margin-right: auto;
filter: drop-shadow(0 0 8px grey);
} 

@media (max-width: 768px) {
.pic{
  /* height: 100%; */
  /* width: 100%; */
}  


}
.home {
margin-top: 7%;
font-size: xxx-large;
margin-bottom: 0px; 
}

@media (min-width:350px) and (max-width: 1000px) {
  .home{
    margin-top: 30%;
    font-size: xxx-large;
    margin-bottom: 0px; 
}  
}

@media (min-width:2400px) and (max-width: 3440px) {
.pic{
  margin-left: -15%;
  margin-left: auto;
margin-right: auto;
width: 100%;
}  
.container{
zoom: 1.6;
}
.h1{
font-size: xx-large;
zoom: 1.5;
}
h1.h1.home {
font-size: xxx-large;
margin-top: 7%;
}
.h3{
font-size: xx-large;
/* zoom: 1.5; */
}
/* .btn1{
font-size: xx-large;
padding: -1000px;
} */


}


.animated-svg {
animation: rotateAnimation 4s linear infinite; /* adjust the duration and other properties as needed */
}

/* @keyframes rotateAnimation {
0% {
  transform: rotate(0deg);
}
100% {
  transform: rotate(360deg);
}
} */
`, "",{"version":3,"sources":["webpack://./src/Pages/main.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf,UAAU;AACV,gBAAgB;AAChB,iBAAiB;;AAEjB;;AAEA;AACA,sBAAsB;AACtB,gBAAgB;AAChB,iBAAiB;AACjB,UAAU;AACV,aAAa;AACb,0BAA0B;AAC1B,2BAA2B;AAC3B,kBAAkB;AAClB,iBAAiB;AACjB;;AAEA;AACA,YAAY;AACZ,aAAa;AACb,gBAAgB;AAChB,cAAc;AACd,iBAAiB;AACjB,kBAAkB;AAClB,iCAAiC;AACjC;;AAEA;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;;AAGA;AACA;AACA,cAAc;AACd,oBAAoB;AACpB,kBAAkB;AAClB;;AAEA;EACE;IACE,eAAe;IACf,oBAAoB;IACpB,kBAAkB;AACtB;AACA;;AAEA;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB,kBAAkB;AAClB,WAAW;AACX;AACA;AACA,SAAS;AACT;AACA;AACA,mBAAmB;AACnB,SAAS;AACT;AACA;AACA,oBAAoB;AACpB,cAAc;AACd;AACA;AACA,mBAAmB;AACnB,eAAe;AACf;AACA;;;GAGG;;;AAGH;;;AAGA;AACA,6CAA6C,EAAE,uDAAuD;AACtG;;AAEA;;;;;;;GAOG","sourcesContent":[".pic{\n  display: flex;\nwidth: 80%;\nmargin-left: 10%;\nmargin-right: 10%;\n\n}\n\n.pic.home {\nwidth: 100% !important;\nmargin-left: 10%;\nmargin-right: 10%;\nwidth: 80%;\ndisplay: flex;\nmargin-left: 0% !important;\nmargin-right: 0% !important;\nmargin-bottom: 0px;\nmargin-top: -50px;\n}\n\n.image4{\nwidth: 600px;\nheight: 400px;\nmargin-top: 3rem;\ndisplay: block;\nmargin-left: auto;\nmargin-right: auto;\nfilter: drop-shadow(0 0 8px grey);\n} \n\n@media (max-width: 768px) {\n.pic{\n  /* height: 100%; */\n  /* width: 100%; */\n}  \n\n\n}\n.home {\nmargin-top: 7%;\nfont-size: xxx-large;\nmargin-bottom: 0px; \n}\n\n@media (min-width:350px) and (max-width: 1000px) {\n  .home{\n    margin-top: 30%;\n    font-size: xxx-large;\n    margin-bottom: 0px; \n}  \n}\n\n@media (min-width:2400px) and (max-width: 3440px) {\n.pic{\n  margin-left: -15%;\n  margin-left: auto;\nmargin-right: auto;\nwidth: 100%;\n}  \n.container{\nzoom: 1.6;\n}\n.h1{\nfont-size: xx-large;\nzoom: 1.5;\n}\nh1.h1.home {\nfont-size: xxx-large;\nmargin-top: 7%;\n}\n.h3{\nfont-size: xx-large;\n/* zoom: 1.5; */\n}\n/* .btn1{\nfont-size: xx-large;\npadding: -1000px;\n} */\n\n\n}\n\n\n.animated-svg {\nanimation: rotateAnimation 4s linear infinite; /* adjust the duration and other properties as needed */\n}\n\n/* @keyframes rotateAnimation {\n0% {\n  transform: rotate(0deg);\n}\n100% {\n  transform: rotate(360deg);\n}\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
